module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded == 'true') ? _c('span', [(_vm.programa.acf.imagen_horizontal != false) ? _c('main', {
    staticClass: "col-xs-12 npd"
  }, [_c('img', {
    attrs: {
      "src": _vm.programa.acf.imagen_horizontal.sizes['1440x446'],
      "alt": "",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "col-xs-12 block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.programa.title.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.locutores), function(locutor) {
    return (_vm.loaded_locutores == 'true') ? _c('figure', {
      staticClass: "col-xs-12 col-md-3 persona"
    }, [(locutor.better_featured_image.hasOwnProperty('media_details')) ? _c('img', {
      attrs: {
        "src": locutor.better_featured_image.media_details.sizes['530x626'].source_url,
        "alt": ""
      }
    }) : _vm._e()]) : _c('figure', {
      staticClass: "col-xs-12 col-md-3 persona"
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5 desprog"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.programa.content.rendered)
    }
  }), _vm._v(" "), _vm._l((_vm.locutores), function(locutor) {
    return (_vm.loaded_locutores == 'true') ? _c('span', [_c('router-link', {
      staticClass: "btn celeste",
      attrs: {
        "to": {
          name: 'locutor',
          params: {
            locutor: locutor.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tLEER MÁS SOBRE EL LOCUTOR\n\t\t\t\t\t\t")])], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [(_vm.programa.acf.hasOwnProperty('horarios_texto')) ? _c('div', {
    staticClass: "col-xs-12 npd horario"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.programa.acf.horarios_texto)
    }
  })]) : _vm._e()])], 2)])])]), _vm._v(" "), (_vm.loaded_audios === 'true') ? _c('div', {
    staticClass: "col-xs-12 block reproductor programacion"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "player__playlist"
  }, [_c('div', {
    staticClass: "compartir__player"
  }, [_vm._m(1), _vm._v(" "), _c('ul', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.programa.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.programa.link + '&text=' + _vm.programa.title.rendered,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "itemwa"
  }, [_c('a', {
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.programa.link
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])])])])]), _vm._v(" "), _c('a', {
    staticClass: "fav__player",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon star",
    attrs: {
      "programa": _vm.programa.id
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "playlist"
  }, _vm._l((_vm.audios), function(audio) {
    return (audio.better_featured_image.hasOwnProperty('media_details')) ? _c('li', {
      staticClass: "col-xs-12 npd",
      attrs: {
        "data-cover": audio.better_featured_image.media_details.sizes.thumbnail.source_url,
        "data-descripcion": audio.soloexcerpt
      }
    }, [_c('a', {
      attrs: {
        "href": audio.post_meta_fields._enclosure_mp3
      }
    }, [_c('span', {
      staticClass: "titulo",
      domProps: {
        "innerHTML": _vm._s(audio.title.rendered)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "autor",
      domProps: {
        "innerHTML": _vm._s(audio.acf.locutor[0].post_title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fecha",
      domProps: {
        "innerHTML": _vm._s(audio.fechaconformatocorto)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "duracion",
      domProps: {
        "innerHTML": _vm._s(audio.post_meta_fields._duration.dur)
      }
    })])]) : _vm._e()
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.loaded_programas == 'true') ? _c('section', {
    staticClass: "hidden-xs hidden-sm col-md-12 block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("OTROS PROGRAMAS")]), _vm._v(" "), _vm._l((_vm.programas), function(programa) {
    return _c('div', {
      staticClass: "col-xs-12 col-xs-6 col-md-3 progitem"
    }, [_c('div', {
      staticClass: "col-xs-12 npd progitem__wrap paused"
    }, [_c('router-link', {
      staticClass: "toint",
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: programa.slug
          }
        }
      }
    }, [_c('figure', [(programa.better_featured_image != 'false') ? _c('img', {
      attrs: {
        "src": programa.better_featured_image.media_details.sizes.medium.source_url,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programa.jpg',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-centermid progitem__des"
    }, [_c('p', [_c('i', {
      staticClass: "icon time"
    }), _c('span', {
      domProps: {
        "innerHTML": _vm._s(programa.acf.horarios_texto)
      }
    })])])]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(programa.title.rendered)
      }
    })])], 1)])
  })], 2)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hor_head"
  }, [_c('h3', [_vm._v("HORARIOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('i', {
    staticClass: "icon share"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aa4f19f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/programa.vue
// module id = 118
// module chunks = 0